import type { BasicAuthResponse } from '#shared/utils/api-types'
import { withQuery } from 'ufo'

export function useBasicAuth(passwordError?: Ref<string | undefined>) {
  return useMutation({
    mutationKey: ['basic-auth'],
    async mutationFn(data: { password: string, email: string, redirectTo?: string }) {
      return await $fetch<BasicAuthResponse>('/api/auth/basic', {
        query: { redirectTo: data.redirectTo } satisfies RedirectToQuery,
        method: 'POST',
        body: data,
        onResponseError(ctx) {
          if (passwordError && ctx.response.status === 401) {
            passwordError.value = 'Feil passord'
          }
        },
      })
    },
    onSuccess({ successUrl, tokenId }) {
      window.location.href = withQuery(successUrl, { tokenId })
    },
  })
}
